export default __webpack_public_path__ + "static/media/bird.23350315.png";